/**
 * AyudaPage component
 * @returns <AyudaPage />
 */
import Breadcrumbs from "../components/Breadcrumbs";
import Accordion from "../components/Accordion";
import { useGetAyudaDataQuery } from "../redux/apiSlice";

import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Loader from "../components/Loader";

const AyudaPage = () => {
    const location = useLocation();

    // BreadcrumbsProps define links for the Breadcrumbs component
    const BreadcrumbsProps = {
        links: [
            {
                link: "/",
                label: "Inicio",
            },
            {
                link: location.pathname,
                label: location.pathname.slice(1),
            },
        ],
    };

    // Fetches ayuda data from the apiSlice
    const { data, isLoading, isFetching, isSuccess, isError } = useGetAyudaDataQuery();

    return (
        <>
            {isLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}

            {isSuccess && (
                <>
                    {/* Renders Breadcrumbs component */}
                    <Breadcrumbs {...BreadcrumbsProps} />

                    {/* Renders the Ayuda section */}
                    <section className="ayuda" style={{ backgroundColor: "white" }}>
                        <div className="wrapper">
                            {/* Renders the main title */}
                            <h1>{data.title}</h1>

                            {/* Renders the Accordion component with ayuda data */}
                            <Accordion items={data.accordion.items} />
                        </div>
                    </section>
                </>
            )}

            {/* Renders an error message if there's an issue fetching the data */}
            {isError && <p>Hubo un error</p>}
        </>
    );
};

export default AyudaPage;
